import React, { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import { Release } from "types/release";

export const useReleases = () => {
  const [releases, setReleases] = React.useState<Release[]>([]);
  const [fetching, setFetching] = React.useState(true);
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    (async () => {
      try {
        setFetching(true);
        const response = await axios.get(
          `${API_BASE_URL}${API_URLS.Releases}`,
          { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
        );
        setReleases(response.data.data);
      } catch (e) {
        console.error(e);
      } finally {
        setFetching(false);
      }
    })();
  }, []);
  return { releases, fetching };
};
